import api from './api';

const leaderboardService = {
  // board: 'received' | 'given' | 'streaks'
  // period: 'day' | 'week' | 'month' | 'year'
  // scope:  'team' | 'org'
  // teamId: which team, when scope is 'team'. Omitted means every team the
  //         viewer belongs to.
  // Omitting any of them falls back to the org's configured default.
  getLeaderboard: async ({ board, period, scope, teamId, limit } = {}) => {
    const params = {};
    if (board) params.board = board;
    if (period) params.period = period;
    if (scope) params.scope = scope;
    if (teamId) params.team_id = teamId;
    if (limit) params.limit = limit;
    const response = await api.get('/api/v1/leaderboard', { params });
    return response.data;
  },
};

export default leaderboardService;
